module.exports = __webpack_public_path__ + "static/media/digital-media.4ccb7f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/digital-media.png
// module id = 1064
// module chunks = 0